import React, {useState} from "react";
import "./software-and-data-downloads.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import {useDispatch, useSelector} from "react-redux";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import {getClientSoftwareDataDownloads} from "../../../redux/clientdata/client.action";
import moment from "moment";
import {ClientServices} from "../../../redux/clientdata/client.services";
import {BREEZE_EMAIL_ADDRESS} from "../../../js/api/_config";

function SoftwareAndDataDownloads({
                                      title,
                                      filterOne,
                                      filterTwo,
                                      tableItemsOne,
                                      tableItemsTwo,
                                      categoriesOne,
                                      categoriesTwo,
                                      tableOneColumnWidth = "210px",
                                      tableTwoColumnWidth = "210px",
                                  }) {
    const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
    const [activeDisplay, setAtiveDisplay] = useState(filterOne);
    const [tableCategories, setTableCategories] = useState(categoriesOne);
    const [tableItems, setTableItems] = useState(tableItemsOne);

    const userSoftwareDataList = useSelector(({client}) => client.softwareAndDataDownloadList);
    const improfileuser = useSelector(({cart}) => cart.impersonateMember.userprofile);
    const dispatch = useDispatch();
    const userEmailData = useSelector(({user}) => user.loggedin_user);//changed from verified_email to loggedin_user
    const [profileuser, setProfileuser] = useState(improfileuser ? improfileuser.Email : userEmailData.Username);
    React.useEffect(() => {
        dispatch(getClientSoftwareDataDownloads(profileuser))
    }, []);

    const toggleDisplayOne = () => {
        setTableColumnWidth(tableOneColumnWidth);
        setAtiveDisplay(filterOne);
        setTableCategories(categoriesOne);
        setTableItems(tableItemsOne);
    };


    if (userSoftwareDataList.length === 0) {
        return (<EmptyTableComponent message={"You do not have any software downloads"}/>);
    }

    const onClickDownload = (fileName) => {
        let processedFileName = fileName.split('.').slice(0, -1).join('.');
        ClientServices.getSoftwareAndDataDownloadCertificate(processedFileName).then(e => {
            // window.open(e.licenseFileUrl, "_blank");
            const link = document.createElement('a');
            link.href = e.licenseFileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    };

    const onClickEmailMaintenanceExpired = () => {
        let mailToLink = 'mailto:' + BREEZE_EMAIL_ADDRESS + '?subject=' + "Maintenance Renewal Request"
        window.open(mailToLink, '_blank');
    }

    return (
        <div className="dual-set-data-table">
            <div className="trinity-container">
                <h2 className="d-lg-none">{title}</h2>
                <div className="section-filters mt-3 mb-3">
                    <span className={`filter clickable ${activeDisplay === filterOne ? "bold" : ""}`}
                          onClick={toggleDisplayOne}>
                        {filterOne}
                    </span>
                </div>
            </div>

            <div className="data-table-container">
                <div className="overflow-width-setter">
                    <div className="table-categories mb-3">
                        <div className="trinity-container d-flex fluid">
                            {tableCategories.map((category) => (
                                <h5
                                    key={category}
                                    style={{width: tableColumnWidth}}
                                    className="category column m-0">
                                    <span className="mr-2">{category}</span>
                                </h5>
                            ))}
                        </div>
                    </div>

                    {userSoftwareDataList && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {userSoftwareDataList.map((item, i) => {
                                    // { customer_id, data, software, edition, version, released, activated, maintenance }
                                    return (
                                        <div key={Math.random() * 100 + i} className="table-item">
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.CustomerId}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.Software}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.EditionName}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.Version && item.Version}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {moment(item.Released).format("MMMM DD, YYYY")}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {item.ActivationStatus}
                                            </div>
                                            <div key={Math.random()} style={{width: tableColumnWidth}}
                                                 className="column">
                                                {moment(item.EndDate).format("MMMM DD, YYYY")}
                                            </div>
                                            <div className="column">
                                                <CustomButton
                                                    mailto="mailto:no-reply@example.com"
                                                    onClick={
                                                        () => !moment(item.EndDate).isSameOrAfter(new Date(), 'day')
                                                            ? onClickEmailMaintenanceExpired()
                                                            : onClickDownload(item.SoftwareFileName)
                                                    }>
                                                    {
                                                        !moment(item.EndDate).isSameOrAfter(new Date(), 'day') ? "Maintenance Expired" : "Download"
                                                    }
                                                </CustomButton>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SoftwareAndDataDownloads;
